module.exports = __webpack_public_path__ + "img/logo_text.c4e8f617.png";